<template>
    <view class="picker-box">
        <view class="picker_sure_warp">
            <text class="picker_cancel" @click="handleCancel">取消</text>
            <text class="picker_sure" @click="selectCity">确定</text>
        </view>
        <picker-view @change="bindPoiPickerColumnChange" :value="timesIndex" class="picker-view" indicator-style="height: 80rpx;">
            <picker-view-column>
                <view class="item" v-for="(item, index) in cityList" :key="item.id">{{
                    item.name
                }}</view>
            </picker-view-column>
            <picker-view-column>
                <view class="item" v-for="(item, index) in twoList" :key="item.id">{{
                    item.name
                }}</view>
            </picker-view-column>
        </picker-view>
    </view>
</template>

<script>
export default {
    data() {
        return {
            // cityList: getApp().globalData.cityList, //原始城市数组
            timesIndex: [0, 0] //选中的序号
        }
    },
    created() {
        console.log('城市列表：', this.cityList)
        // console.log('--------------',this.cityList)
    },
    computed: {
        twoList() {
            return this.cityList[this.timesIndex[0]].sub
        },
        cityList() {
            return this.$store.state.cityList
        }
    },
    methods: {
        //picker滚动
        bindPoiPickerColumnChange(e) {
            console.log(e)
            this.timesIndex = e.detail.value
        },
        //取消
        handleCancel() {
            // this.$refs.pickerPop.close()
            this.$emit('changeCity', 2)
        },
        //选择城市
        selectCity() {
            console.log(111)
            try {
                const item = this.twoList[this.timesIndex[1]]
                const obj = {
                    id: item.id, // 城市id
                    name: item.name // 城市名称
                }
                this.cityName = item.name
                this.$store.commit('setCityInfo', obj)
                setTimeout(() => {
                    this.$emit('changeCity', 1)
                }, 100)
            } catch (e) {
                //TODO handle the exception
                console.log(e)
            }
        }
    }
}
</script>

<style scoped lang="less">
.picker-box {
	padding-bottom: var(--window-bottom);
}
.picker_sure_warp {
    background-color: #ffffff;
    display: flex;
    justify-content: space-around;
    padding: 20upx 40upx;
    z-index: 111;
    .picker_sure {
        width: 50%;
        text-align: right;
    }
    .picker_cancel {
        width: 50%;
    }
}
.picker-view {
    width: 750upx;
    height: 400upx;
    text-align: center;
    background-color: #ffffff;
}
.item {
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
